// Client-side validation for the 'sizingBands' admin setting (AHA-6796).
// Mirrors the per-band rules of the server-side SizingBandsSchema
// (@alpinehomeair/common): both percents finite and
// > 0, lowerPercent <= upperPercent (equal bounds are valid). The schema's
// presence/duplicate checks (exactly one band per equipment type) are
// structurally guaranteed here — the form renders exactly one fixed row per
// equipment type, with no add/remove — so they are not re-validated.
// An empty result object means the form is valid.
export type SizingBandEquipmentType = 'acCooling' | 'hpCooling' | 'heating';

export type SizingBandRowDraft = {
  equipmentType: SizingBandEquipmentType;
  lowerPercent: number | undefined;
  upperPercent: number | undefined;
};

export type SizingBandRowErrors = {
  lowerPercent?: string;
  upperPercent?: string;
};

export interface SizingBandsErrors {
  rows?: Record<number, SizingBandRowErrors>;
}

export function validateSizingBands(
  rows: SizingBandRowDraft[]
): SizingBandsErrors {
  const errors: SizingBandsErrors = {};
  const rowErrors: Record<number, SizingBandRowErrors> = {};

  rows.forEach((row, index) => {
    const error: SizingBandRowErrors = {};
    const lowerValid =
      row.lowerPercent !== undefined && Number.isFinite(row.lowerPercent);
    const upperValid =
      row.upperPercent !== undefined && Number.isFinite(row.upperPercent);

    if (!lowerValid) {
      error.lowerPercent = 'Enter a number';
    } else if ((row.lowerPercent as number) <= 0) {
      error.lowerPercent = 'Must be greater than 0';
    }

    if (!upperValid) {
      error.upperPercent = 'Enter a number';
    } else if ((row.upperPercent as number) <= 0) {
      error.upperPercent = 'Must be greater than 0';
    } else if (
      lowerValid &&
      !error.lowerPercent &&
      (row.lowerPercent as number) > (row.upperPercent as number)
    ) {
      error.upperPercent = 'Must be greater than or equal to the lower percent';
    }

    if (Object.keys(error).length > 0) {
      rowErrors[index] = error;
    }
  });

  if (Object.keys(rowErrors).length > 0) {
    errors.rows = rowErrors;
  }
  return errors;
}
